<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-03-01 16:26:37
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveType\newLeaveType.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveType_form_newTitle')"
    widthClass="max-1000"
    pad="0"
    :initData="LeaveTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'leave_type_name',
      'color_code',
      'sequence',
      'unit',
      'remarks',
      'leave_type_code',
      'leave_type_abbr',
      'leave_type_property_group_uuid',
      'leave_type_description',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  :bindData="LeaveTypeData.leave_type_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      LeaveTypeData.leave_type_name = valueArr;
                    }
                  "
                  :label="$t('label_essweb_leaveType_form_leaveTypeNameLabel')"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <!-- <v-col  xs='12' sm="6" md='6' lg='6' cols="12">
                <inputTextFiledMultiLang
                  filled
                  single-line
                  dense
                  :bindData="LeaveTypeData.count_method"
                  
                  @change="valueArr=>{
                            LeaveTypeData.count_method=valueArr;
                        }"
                  :counter="15"
                  label="Count Method"
                  :rules="$GetRules(['_Require_Rules', '_Length_Rules'],[null, 15])"
                />
              </v-col>-->
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  maxlength="20"
                  :bindData="LeaveTypeData.leave_type_abbr"
                  @change="
                    (valueArr) => {
                      LeaveTypeData.leave_type_abbr = valueArr;
                    }
                  "
                  :rules="$GetRules('_Require_Rules', [null])"
                  :label="$t('label_essweb_leaveType_form_leaveTypeAbbrLabel')"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  type="number"
                  :label="$t('label_essweb_leaveType_form_sequenceLabel')"
                  maxlength="255"
                  :rules="
                    $GetRules(
                      ['_Number_negative', '_Length_Rules'],
                      [null, 255]
                    )
                  "
                  isNotRequire
                  v-model="LeaveTypeData.sequence"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_leaveType_form_unitLabel")
                }}</v-sheet>
                <v-select
                  v-model="LeaveTypeData.unit"
                  :items="Units"
                  item-value="value_field"
                  item-text="view_fields"
                  filled
                  single-line
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  :rules="$GetRules('_Require_Rules', [null])"
                  dense
                  :label="$t('label_essweb_leaveType_form_unitLabel')"
                >
                  <template v-slot:no-data> <noContent /> </template>

                  <template v-slot:selection="{ item, index }">
                    {{ $getCommonLangValue(item.view_fields) }}
                  </template>
                  <template v-slot:item="{ item, index }">
                    {{ $getCommonLangValue(item.view_fields) }}
                  </template></v-select
                >
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :label="
                    $t(
                      'label_essweb_leaveTransactionPropertyGroup_form_codeLabel'
                    )
                  "
                  :rules="$GetRules('_Require_Rules', [null])"
                  maxlength="50"
                  v-model="LeaveTypeData.leave_type_code"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  :bindData="LeaveTypeData.leave_type_description"
                  @change="
                    (valueArr) => {
                      LeaveTypeData.leave_type_description = valueArr;
                    }
                  "
                  :label="$t('label_essweb_leaveType_form_descriptionLabel')"
                />
              </v-col>

              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_leaveType_form_leaveTypePropertyGroupLabel")
                }}</v-sheet>
                <v-autocomplete
                  v-model="LeaveTypeData.leave_type_property_group_uuid"
                  :items="propertyGroup"
                  item-value="uuid"
                  item-text="leave_type_property_group_name"
                  filled
                  single-line
                  :rules="$GetRules('_Require_Rules', [null])"
                  dense
                  :placeholder="
                    $t(
                      'label_essweb_leaveType_form_leaveTypePropertyGroupLabel'
                    )
                  "
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_leaveType_form_tagColorLabel")
                }}</v-sheet>
                <SelectColor
                  :items="Colors"
                  v-model="LeaveTypeData.color_code"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_leaveType_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  filled
                  single-line
                  dense
                  counter="500"
                  v-model="LeaveTypeData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-container fluid class="mrc-grey rounded-lg">
            <!-- <draggable
              v-model="dragArr"
              draggable=".drag"
              v-bind="{ animation: 1000 }"
              :list="NoticeList"
            >-->
            <v-sheet
              class="rounded-lg pa-0 drag mt-2 mb-2"
              v-for="(item, index) in NoticeList"
              :key="index"
            >
              <v-hover v-slot:default="{ hover }" open-delay="100">
                <v-card
                  class="pa-2 d-flex rounded-lg align-center"
                  :elevation="hover ? 4 : 2"
                >
                  <!-- bug847 mel -->
                  <!-- <svg-icon size="36" fill="grey" iconClass="dragvertical" 
                    style="min-width: 36px"
                  /> -->
                  <svg-icon
                    size="36"
                    fill="black"
                    iconClass="arrow01"
                    style="min-width: 36px"
                  />
                  <span class="text-body-2">
                    {{
                      $getCommonLangValue(
                        item["leave_type_notice_point_" + item.number]
                      )
                    }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn icon v-if="hover" @click="toEditNotice(item)">
                    <span class="material-icons-round">edit</span>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    v-if="hover"
                    @click="onDeleteNotice(item.number)"
                  >
                    <span class="material-icons-round">delete</span>
                  </v-btn>
                </v-card>
              </v-hover>
            </v-sheet>
            <!-- </draggable> -->
          </v-container>
        </template>
        <template v-slot:content-3>
          <v-card :elevation="0" class="pa-0">
            <v-card-text class="pa-0">
              <Tabler
                :headers="headers"
                :showNoContent="false"
                :items="desserts"
              >
                <template v-slot:item.holiday_type_name="{ item }">{{
                  $getCommonLangValue(item.holiday_type_name)
                }}</template>
                <template v-slot:item.holiday_type_code="{ item }">{{
                  item.holiday_type_code
                }}</template>
              </Tabler>
            </v-card-text>
            <v-card-actions class="pb-0 pl-0">
              <v-btn
                text
                color="primary"
                small
                class="text-capitalize mb-3"
                @click="toNewMapping"
              >
                {{ $t("label_essweb_leaveType_form_editHolidayTypeBtnLabel") }}
                <span class="material-icons-round">add</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="step == curStep && curStep != 0 ? true : false"
        :step="step == curStep ? false : true"
        @next="toNext"
        :onLoading="isLoading"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <template v-slot:tools-main>
      <newNotice
        :show="showNewNotice"
        @close="
          showNewNotice = false;
          NoticePropertyData = null;
        "
        :PropertyData="NoticePropertyData"
        @onNew="onNewNotice"
      />
      <editHolidayType
        :show="mapToDiag"
        :PorpertyData="curPorperty"
        @editPorperty="onEditProperty"
        @close="mapToDiag = false"
      />
    </template>
  </ContentLayout>
</template>
<script>
import draggable from "vuedraggable";

import { mapGetters } from "vuex";
import newNotice from "@/Page/EssAdmin/Leave/LeaveType/components/newNotice";
import editHolidayType from "@/Page/EssAdmin/Leave/LeaveType/components/editHolidayType";
export default {
  name: "newLeaveType",
  components: { draggable, newNotice, editHolidayType },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "isLoading"]),
  },
  data() {
    return {
      Colors: [],
      iSEdited: false,
      dragArr: [],
      isChanged: false,
      showNewNotice: false,
      willClearNotice: null,
      NoticeList: [],
      NoticePropertyData: null,
      stepper: [
        "label_essweb_leaveType_form_step_generalLabel",
        "label_essweb_leaveType_form_step_noticeLabel",
        "label_essweb_leaveType_form_step_HolidayTypeLabel",
      ],
      curStep: 1,
      step: 3,
      Units: [],
      mapToDiag: false,
      curPorperty: null,
      showDelete: false,
      LeaveTypeData: {
        leave_type_name: "",
        color_code: "",
        remarks: "",
        unit: "",
        sequence: 1,
        leave_type_abbr: "",
        leave_type_code: "",
        count_method: {},
        leave_type_property_group_uuid: "",
        leave_type_description: "",
      },
      propertyGroup: [],
      holidayUuids: [],
      headers: [
        {
          text: "label_essweb_holidayType_list_HolidayTypeNameLabel",
          value: "holiday_type_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayType_list_HolidayTypeCodeLabel",
          value: "holiday_type_code",
          align: "start",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  watch: {
    desserts(val) {
      const that = this;
      that.holidayUuids = [];
      this.curPorperty = val;
      val.forEach(function (item) {
        that.holidayUuids.push(item.uuid);
      });
    },
  },
  mounted() {
    //初始化
    // this.LeaveTypeData.leave_type_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // // this.LeaveTypeData.count_method = this.$getCommonLangKey(this.companyLang);
    // this.LeaveTypeData.leave_type_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.NoticeList = [];
    for (let i = 0; i < 5; i++) {
      let json = {};
      json["leave_type_notice_point_" + (i + 1)] = this.$transCommonLangKey(
        this.$getCommonLangKey(this.companyLang)
      );

      json["number"] = i + 1;
      this.NoticeList.push(json);
    }
    this.getColors();
    this.getUnits();
    this.getLeavePropertyGroup();
  },
  methods: {
    toNewMapping: function () {
      const that = this;
      this.curPorperty = [];
      this.$Sleep(300).then(() => {
        that.curPorperty = that.desserts;
      });
      this.mapToDiag = true;
    },
    onEditProperty: function (obj) {
      this.mapToDiag = false;
      this.desserts = obj;
    },
    getColors() {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_color_leave_select",
      }).then((res) => {
        that.Colors = [];
        res.data.map((item) => {
          that.Colors.push({
            text: item.view_fields,
            color: item.value_field,
          });
        });
      });
    },
    getUnits: function () {
      this.$findPrompt({
        prompt_name: "ess_leaveT_unit_select",
      }).then((res) => {
        this.Units = res.data;
      });
    },
    toEditNotice: function (obj) {
      this.NoticePropertyData = obj;
      this.showNewNotice = true;
    },
    onDeleteNotice: function (number) {
      const that = this;
      this.willClearNotice = number;
      this.$confirmDo(
        this.$t("label_essweb_leaveType_form_step_noticeLabel")
      ).then((res) => {
        if (res) that.toClearNotice();
      });
    },
    toClearNotice: function () {
      const that = this;
      this.NoticeList.map((item) => {
        if (item.number == that.willClearNotice) {
          item["leave_type_notice_point_" + that.willClearNotice] =
            that.$transCommonLangKey(that.$getCommonLangKey(that.companyLang));
        }
      });
    },
    getLeavePropertyGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_property_group",
        url: "/leave-type-property-group/get-list/",
        data: {},
      }).then((res) => {
        res.data.map((item) => {
          item.leave_type_property_group_name = that.$getCommonLangValue(
            item.leave_type_property_group_name
          );
        });
        that.propertyGroup = res.data;
      });
    },
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    onNewNotice: function (notice, number) {
      this.NoticePropertyData = null;
      this.NoticeList.map((item) => {
        if (item.number == number) {
          item["leave_type_notice_point_" + number] =
            this.$transCommonLangKey(notice);
        }
      });
      this.showNewNotice = false;
    },
    toNew: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let noticeArr = [{}];
      this.NoticeList.map((item, index) => {
        noticeArr[0]["leave_type_notice_point_" + item.number] =
          item["leave_type_notice_point_" + item.number];
      });
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/add/",
        data: {
          leave_type_name: this.$transCommonLangKey(
            this.LeaveTypeData.leave_type_name
          ),
          leave_type_description: this.$transCommonLangKey(
            this.LeaveTypeData.leave_type_description
          ),
          leave_type_abbr: this.$transCommonLangKey(
            this.LeaveTypeData.leave_type_abbr
          ),
          leave_type_code: this.LeaveTypeData.leave_type_code,
          sequence: this.LeaveTypeData.sequence,
          unit: this.LeaveTypeData.unit,
          leave_type_property_group_uuid:
            this.LeaveTypeData.leave_type_property_group_uuid,
          color_code: this.LeaveTypeData.color_code,
          ess_lv_leave_type_notice: noticeArr,
          latest_ids: this.holidayUuids.join(","),
          remarks: this.LeaveTypeData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
